"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledInput = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var INPUT_VARIANTS = {
  DEFAULT: 'default',
  INVALID: 'invalid',
  VALID: 'valid',
  SECURE: 'secure',
  // TODO: not used yet
  ACTIVE: 'active',
  DISABLED: 'disabled'
};
var Input = function Input(props) {
  var reference = props.reference,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile;
  return /*#__PURE__*/_react["default"].createElement(StyledInput, (0, _extends2["default"])({}, props, {
    $isMobile: isMobile,
    ref: reference
  }));
};

// TODO: use themes. Cant use now since Internals doesnt have one.
var THEMES = (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, INPUT_VARIANTS.DEFAULT, (0, _styledComponents.css)(["background-color:var(--white);border-color:var(--grey3);&::placeholder{color:var(--grey2);}"])), INPUT_VARIANTS.SECURE, (0, _styledComponents.css)(["background-color:#f2f2f2;border-color:#c2c5cc;&::placeholder{color:#c2c5cc;}"])), INPUT_VARIANTS.VALID, (0, _styledComponents.css)(["background-color:#f2fae8;border-color:#d6d5c3;"])), INPUT_VARIANTS.INVALID, (0, _styledComponents.css)(["background-color:#fffbe8;border-color:#f7aa1b;z-index:2;border-right:0;box-shadow:1px 0 0 0 #f7aa1b;"]));
Input.VARIANTS = INPUT_VARIANTS;
var StyledInput = exports.StyledInput = _styledComponents["default"].input.withConfig({
  displayName: "Input__StyledInput",
  componentId: "sc-q2gnfv-0"
})(["position:relative;border:1px solid;border-radius:var(--border-radius);padding:8px;font-size:14px;font-style:normal;font-weight:400;line-height:16px;", " ", " ", " ", ";"], function (props) {
  return props.$isMobile && (0, _styledComponents.css)(["font-size:16px;line-height:20px;padding:12px 16px;"]);
}, function (props) {
  return !props.disabled && (0, _styledComponents.css)(["&:hover,&:focus{border-color:var(--black);}&:focus{background-color:var(--white);}"]);
}, function (props) {
  return props.disabled && 'opacity: var(--disabled-opacity);';
}, function (props) {
  return THEMES[props.variant];
});
Input.propTypes = {
  autoFocus: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  onBlur: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onInput: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  reference: _propTypes["default"].any,
  type: _propTypes["default"].string,
  value: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(Object.values(INPUT_VARIANTS))
};
Input.defaultProps = {
  autoFocus: false,
  className: '',
  disabled: false,
  onBlur: Function.prototype,
  onChange: Function.prototype,
  onClick: Function.prototype,
  onFocus: Function.prototype,
  onInput: Function.prototype,
  placeholder: '',
  reference: null,
  type: 'text',
  value: undefined,
  variant: INPUT_VARIANTS.DEFAULT
};
var _default = exports["default"] = Input;